import React from 'react';
import {
  Tooltip as WixTooltip,
  TooltipTextAlign,
  TooltipSize,
} from '@wix/design-system';

interface Props {
  active?: boolean;
  appendToParent?: boolean;
  appendTo?: any;
  children: React.ReactNode;
  content: React.ReactNode;
  dataHook?: string;
  disabled?: boolean;
  maxWidth?: number | string; // 200 || '200px'
  minWidth?: number | string; // 200 || '200px'
  moveBy?: any;
  size?: TooltipSize;
  showTrigger?: string;
  hideTrigger?: string;
  placement?: 'bottom' | 'top' | 'left' | 'right';
  shouldCloseOnClickOutside?: boolean;
  showDelay?: number;
  hideDelay?: number;
  theme?: string;
  textAlign?: TooltipTextAlign;
  zIndex?: number;
  inline?: boolean;

  onHide?(): void;

  onShow?(): void;
}

export const Tooltip = ({ children, ...props }: Props) => (
  <WixTooltip placement="top" enterDelay={0} exitDelay={0} {...props}>
    {children}
  </WixTooltip>
);

export default Tooltip;
